export const serialRun = async (arr) => {
    let result = [];
    for(let a of arr){
        let t = await a;
        result.push(t);
    }
    return result
}